import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {algoliasearch} from 'algoliasearch';
import instantsearch, {IndexWidget, InstantSearch, Widget} from 'instantsearch.js';

@Injectable({
  providedIn: 'root'
})
export class AlgoliaService {

  public instantSearchInstance: InstantSearch;
  private instantSearchIsStarted = false;

  constructor() {
    this.instantSearchInstance = instantsearch({
      searchClient: algoliasearch(environment.algolia.applicationId, environment.algolia.apikey),
      indexName: 'Customers',
      future: { preserveSharedStateOnUnmount: true },
    });
  }

  start() {
    if (this.instantSearchIsStarted) {
      return;
    }
    this.instantSearchInstance.start();
    this.instantSearchIsStarted = true;
  }

  clearQuery() {
    this.instantSearchInstance.helper?.setQuery('');
  }

  addWidgets(widgets: Array<IndexWidget | Widget>) {
    this.instantSearchInstance.addWidgets(widgets);
  }

  removeWidgets(widgets: Array<IndexWidget | Widget>) {
    this.instantSearchInstance.removeWidgets(widgets);
  }
}
